var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-1759.66,-5657)"},React.createElement("g",{"transform":"matrix(1,0,0,1,1719.66,5541)"},React.createElement("g",{"transform":"matrix(1.72222,0,0,2.33333,34.8333,102)"},React.createElement("path",{"d":"M3,18L21,18L21,16L3,16L3,18ZM3,13L21,13L21,11L3,11L3,13ZM3,6L3,8L21,8L21,6L3,6Z","style":{"fill":"white","fillRule":"nonzero"}})))));
}

Menu.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 31 28","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Menu;

Menu.default = Menu;
